import pbgClient, { getNoyoIssuesUrl } from './client'
import type {
  ListNoyoDifferencesParams,
  NoyoDifferencesListResponse,
  NoyoGroupPlan,
  NoyoPlanMembersResponse,
} from './noyo-differences.types'

const BASE = '/api/v1/noyo/differences'

export const listNoyoDifferences = (params: ListNoyoDifferencesParams = {}) =>
  pbgClient
    .get<NoyoDifferencesListResponse>(BASE, {
      params,
      baseURL: getNoyoIssuesUrl(),
    })
    .then((r) => r.data)

export const getNoyoPlatformEmployee = (noyoEmployeeId: string) =>
  pbgClient
    .get<{
      employeePublicKey: string
      name: string
      isNoyoTerminated: boolean
      surecoName: string
      isSurecoTerminated: boolean
    }>(
      `/api/v1/noyo/employees/${encodeURIComponent(noyoEmployeeId)}/platform-employee`,
      { baseURL: getNoyoIssuesUrl() }
    )
    .then((r) => r.data)

export const getNoyoPlanMembers = (
  noyoEmployeeId: string,
  planId?: string,
  lineOfCoverage?: string
) => {
  const params: Record<string, string> = {}
  if (typeof planId === 'string' && planId.length > 0) {
    params.planId = planId
  }
  if (typeof lineOfCoverage === 'string' && lineOfCoverage.length > 0) {
    params.lineOfCoverage = lineOfCoverage
  }
  return pbgClient
    .get<NoyoPlanMembersResponse>(
      `/api/v1/noyo/employees/${encodeURIComponent(noyoEmployeeId)}/plan-members`,
      {
        params,
        baseURL: getNoyoIssuesUrl(),
      }
    )
    .then((r) => r.data)
}

export const getNoyoGroupPlan = (planId: string) =>
  pbgClient
    .get<NoyoGroupPlan>(`/api/v1/noyo/plans/${encodeURIComponent(planId)}`, {
      baseURL: getNoyoIssuesUrl(),
    })
    .then((r) => r.data)
